import wowInit from "./module/wowInit";
import adjustViewport from "./module/adjustViewport";
import smoothScroll from "./module/smoothScroll";
import showGotop from "./module/showGotop";
import headerScroll from "./module/headerScroll";
import showNav from "./module/showNav";
import splideInit from "./module/splideInit";
import "../scss/style.scss";
import "../scss/style.scss";

showNav();
headerScroll();
splideInit();
smoothScroll();